/**
 * Creates a status manager for SDK status and quality metrics
 */
export function createStatusManager() {
  let status = {
    initialized: false,
    measuring: false,
    quality: null,
    warnings: [],
  };

  /**
   * Update status
   */
  const updateStatus = (updates) => {
    status = { ...status, ...updates };
  };

  /**
   * Get current status
   */
  const getStatus = () => {
    return { ...status };
  };

  /**
   * Add warning
   */
  const addWarning = (warning) => {
    status.warnings.push({
      message: warning,
      timestamp: Date.now(),
    });
  };

  /**
   * Clear warnings
   */
  const clearWarnings = () => {
    status.warnings = [];
  };

  /**
   * Reset status
   */
  const reset = () => {
    status = {
      initialized: false,
      measuring: false,
      quality: null,
      warnings: [],
    };
  };

  return {
    updateStatus,
    getStatus,
    addWarning,
    clearWarnings,
    reset,
  };
}
